import { memo } from 'react';

/** A safe wrapper around `React.memo`, which behaves identically at runtime, but correctly
 * retains type parameters (like `Component<T>`).
 */
export const safeMemo: <T>(c: T) => T = memo;
